import { GridTemplateToken } from './types';

/**
 * Internal function for performing the actual expansion of GridTemplateTokens. Makes stronger
 * assumptions than the public `buildMsTemplate` function and is used in recursive grid functions.
 *
 * @param tokens The tokens describing how the cells should be sized
 * @param gap The distance between cells
 * @package
 */
export function expandMsTokens(tokens: GridTemplateToken[], gap?: string | null) {
  return !gap
    ? tokens
        .map((t) => t.expandMsToken())
        .filter(Boolean)
        .join(' ')
    : tokens
        .reduce((expanded, t) => expanded.concat(t.expandMsTokenWithGap(gap)), [] as string[])
        .slice(0, -1)
        .filter(Boolean)
        .join(' ');
}
